export const toast = {
  root: {
    width: "400px",
    borderRadius: "{content.border.radius}",
    borderWidth: "{border.width.1}",
    transitionDuration: "{transition.duration}",
  },
  icon: {
    size: "{icon.size}",
  },
  content: {
    padding: "{overlay.popover.padding}",
    gap: "{gap.8}",
  },
  text: {
    gap: "{gap.8}",
  },
  summary: {
    fontWeight: "500",
    fontSize: "{content.font.size}",
  },
  detail: {
    fontWeight: "400",
    fontSize: "{form.field.sm.font.size}",
  },
  closeButton: {
    width: "{icon.size}",
    height: "{icon.size}",
    borderRadius: "50%",
    focusRing: {
      width: "{focus.ring.width}",
      style: "{focus.ring.style}",
      offset: "{focus.ring.offset}",
    },
  },
  closeIcon: {
    size: "{icon.size}",
  },

  colorScheme: {
    light: {
      root: {
        blur: "1.5px",
      },
      info: {
        background: "{info.support}",
        borderColor: "{info.border}",
        color: "{info.default}",
        detailColor: "{info.default}",
        shadow: "0px 4px 8px 0px rgba(1, 8, 4, 0.04)",
        closeButton: {
          hoverBackground: "transparent",
          focusRing: {
            color: "{info.default}",
            shadow: "none",
          },
        },
      },
      success: {
        background: "{success.support}",
        borderColor: "{success.border}",
        color: "{success.default}",
        detailColor: "{success.default}",
        shadow: "0px 4px 8px 0px rgba(1, 8, 4, 0.04)",
        closeButton: {
          hoverBackground: "transparent",
          focusRing: {
            color: "{success.default}",
            shadow: "none",
          },
        },
      },
      warn: {
        background: "{warning.support}",
        borderColor: "{warning.border}",
        color: "{warning.default}",
        detailColor: "{warning.default}",
        shadow: "0px 4px 8px 0px rgba(1, 8, 4, 0.04)",
        closeButton: {
          hoverBackground: "transparent",
          focusRing: {
            color: "{warning.default}",
            shadow: "none",
          },
        },
      },
      error: {
        background: "{danger.support}",
        borderColor: "{danger.border}",
        color: "{danger.default}",
        detailColor: "{danger.default}",
        shadow: "0px 4px 8px 0px rgba(1, 8, 4, 0.04)",
        closeButton: {
          hoverBackground: "transparent",
          focusRing: {
            color: "{danger.default}",
            shadow: "none",
          },
        },
      },
      // secondary: {
      //   background: "{surface.100}",
      //   borderColor: "{surface.200}",
      //   color: "{surface.600}",
      //   detailColor: "{surface.700}",
      //   shadow: "0px 4px 8px 0px color-mix(in srgb, {surface.500}, transparent 96%)",
      //   closeButton: {
      //     hoverBackground: "{surface.200}",
      //     focusRing: {
      //       color: "{surface.600}",
      //       shadow: "none",
      //     },
      //   },
      // },
      // contrast: {
      //   background: "{surface.900}",
      //   borderColor: "{surface.950}",
      //   color: "{surface.50}",
      //   detailColor: "{surface.0}",
      //   shadow: "0px 4px 8px 0px color-mix(in srgb, {surface.950}, transparent 96%)",
      //   closeButton: {
      //     hoverBackground: "{surface.800}",
      //     focusRing: {
      //       color: "{surface.50}",
      //       shadow: "none",
      //     },
      //   },
    },
    dark: {
      root: {
        blur: "10px",
      },
      info: {
        background: "{info.support}",
        borderColor: "{info.border}",
        color: "{info.default}",
        detailColor: "{info.default}",
        shadow: "0px 4px 8px 0px rgba(1, 8, 4, 0.04)",
        closeButton: {
          hoverBackground: "transparent",
          focusRing: {
            color: "{info.default}",
            shadow: "none",
          },
        },
      },
      success: {
        background: "{success.support}",
        borderColor: "{success.border}",
        color: "{success.default}",
        detailColor: "{success.default}",
        shadow: "0px 4px 8px 0px rgba(1, 8, 4, 0.04)",
        closeButton: {
          hoverBackground: "transparent",
          focusRing: {
            color: "{success.default}",
            shadow: "none",
          },
        },
      },
      warn: {
        background: "{warning.support}",
        borderColor: "{warning.border}",
        color: "{warning.default}",
        detailColor: "{warning.default}",
        shadow: "0px 4px 8px 0px rgba(1, 8, 4, 0.04)",
        closeButton: {
          hoverBackground: "transparent",
          focusRing: {
            color: "{warning.default}",
            shadow: "none",
          },
        },
      },
      error: {
        background: "{danger.support}",
        borderColor: "{danger.border}",
        color: "{danger.default}",
        detailColor: "{danger.default}",
        shadow: "0px 4px 8px 0px rgba(1, 8, 4, 0.04)",
        closeButton: {
          hoverBackground: "transparent",
          focusRing: {
            color: "{danger.default}",
            shadow: "none",
          },
        },
      },
      // secondary: {
      //   background: "{surface.100}",
      //   borderColor: "{surface.200}",
      //   color: "{surface.600}",
      //   detailColor: "{surface.700}",
      //   shadow: "0px 4px 8px 0px color-mix(in srgb, {surface.500}, transparent 96%)",
      //   closeButton: {
      //     hoverBackground: "{surface.200}",
      //     focusRing: {
      //       color: "{surface.600}",
      //       shadow: "none",
      //     },
      //   },
      // },
      // contrast: {
      //   background: "{surface.900}",
      //   borderColor: "{surface.950}",
      //   color: "{surface.50}",
      //   detailColor: "{surface.0}",
      //   shadow: "0px 4px 8px 0px color-mix(in srgb, {surface.950}, transparent 96%)",
      //   closeButton: {
      //     hoverBackground: "{surface.800}",
      //     focusRing: {
      //       color: "{surface.50}",
      //       shadow: "none",
      //     },
      //   },
    },
  },
  extend: {
    ui: {
      maxWidth: "calc(100% - 40px)",
    },
  },
  css: ({ dt }: any): string => `
    .p-toast {
      max-width: ${dt("toast.ui.max.width")};
    }

    .p-toast-detail:empty {
      display: none;
    }

    .p-toast-detail {
      white-space: pre-wrap;
    }

    .p-toast-message-text {
      max-height: 20vh;
      overflow-x: auto;
    }

    .p-toast-message-icon {
      line-height: inherit;
    }

    .p-toast-close-button {
      display: inline-flex;
      vertical-align: middle;
    }
  `,
};
